/* Pénombre — filtre trafic publicitaire hors zone de livraison / bots.
 * Portée volontairement étroite : ne s'active que sur les sessions arrivées via un clic
 * publicitaire (gclid/gbraid/wbraid) ou présentant un signal d'automatisation (navigator.webdriver,
 * etc.). Un visiteur organique normal, quel que soit son pays, n'est jamais concerné.
 *
 * Ce script ne peut pas annuler un clic déjà facturé par Google Ads — seul le ciblage géographique
 * réglé directement dans Google Ads empêche la dépense. Il sert à éviter que ces sessions :
 *  1) faussent les données de conversion (Smart Bidding apprend sur du signal invalide),
 *  2) aillent au bout d'un tunnel d'achat vers une zone que Pénombre ne livre pas de toute façon.
 */
(function(){
  "use strict";

  var ALLOWED_COUNTRIES = ['FR', 'BE', 'CH', 'LU'];
  var STORAGE_KEY = 'luma_traffic_zone';

  function isLikelyBot(){
    try {
      if (navigator.webdriver) return true;
      if (window.outerWidth === 0 || window.outerHeight === 0) return true;
      if (navigator.plugins && navigator.plugins.length === 0 && !/Firefox|Safari|Mobile/i.test(navigator.userAgent)) return true;
      if (/HeadlessChrome|PhantomJS|Selenium/i.test(navigator.userAgent)) return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  function hasAdClickParams(){
    try {
      var params = new URLSearchParams(window.location.search);
      return params.has('gclid') || params.has('gbraid') || params.has('wbraid');
    } catch (e) {
      return false;
    }
  }

  function flagTraffic(zone, reason){
    window.lumaTrafficZone = zone;
    try { sessionStorage.setItem(STORAGE_KEY, zone); } catch (e) {}
    if (zone === 'out_of_zone' || zone === 'bot_suspected') {
      window.lumaPushEvent && window.lumaPushEvent('paid_traffic_flagged', {
        zone: zone,
        reason: reason,
        path: window.location.pathname
      });
    }
  }

  function checkGeo(callback){
    var cached = null;
    try { cached = sessionStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (cached) { callback(cached); return; }

    fetch('https://ipwho.is/', { cache: 'no-store' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        var code = data && data.success !== false ? data.country_code : null;
        var zone = (code && ALLOWED_COUNTRIES.indexOf(code) !== -1) ? 'in_zone' : (code ? 'out_of_zone' : 'unknown');
        flagTraffic(zone, code || 'lookup_failed');
        callback(zone);
      })
      .catch(function(){
        flagTraffic('unknown', 'lookup_error');
        callback('unknown');
      });
  }

  function guardCheckout(zone){
    if (zone !== 'out_of_zone' && zone !== 'bot_suspected') return;

    document.addEventListener('click', function(e){
      var trigger = e.target.closest('a[href*="/checkout"], [data-add-to-cart], [data-sticky-add]');
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (window.lumaToast) {
        window.lumaToast('Pénombre livre uniquement en France, Belgique, Suisse et Luxembourg. Écrivez-nous si votre situation est différente.');
      }
    }, true);
  }

  function init(){
    var botFlag = isLikelyBot();
    if (botFlag) { flagTraffic('bot_suspected', 'client_heuristic'); }

    if (!hasAdClickParams() && !botFlag) return;

    if (botFlag) {
      guardCheckout('bot_suspected');
      return;
    }

    checkGeo(function(zone){
      guardCheckout(zone);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
